// @ts-nocheck
import { getFormById, getForms } from "@store/Framework/Store/Foundation/Components/Form/FormSelector";
import { FormModel, SetInputHandlerParameter } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";

type Parameter = SetInputHandlerParameter;
type Props = {
    forms: FormModel[];
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateFormWithInputs: HandlerType = props => {
    const state = props.getState();
    let forms = getForms(state);
    const form = getFormById(state, props.parameter.formId);

    if (form) {
        forms = [...forms];
        const _form = cloneDeep(form);
        const index = findIndex(_form.inputs, x => x.id === props.parameter.input.id);

        if (index !== -1) {
            _form.inputs.splice(index, 1, props.parameter.input);
        } else {
            _form.inputs.splice(_form.inputs.length, 0, props.parameter.input);
        }

        const formIndex = findIndex(forms, x => x.id === _form.id);
        forms.splice(formIndex, 1, _form);
    }

    props.forms = forms;
};

export const DispatchInput: HandlerType = props => {
    props.dispatch({
        type: "Foundation/Components/Form/SetInput",
        forms: props.forms,
    });
};

export const chain = [PopulateFormWithInputs, DispatchInput];

const setInput = createHandlerChainRunner(chain, "SetInput");

export default setInput;
